import { AxiosPromise } from 'axios'

import api from '@config/api'

interface IUploadData {
  file?: any
}

export function getPurschaseData(data: any, _page: number): AxiosPromise {
  return api.post('v1/Alerta/Compras', data, {})
}

export function getSupplyAlertFollowUp(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoCompra/Fornecedores', data, {})
}

export function getAlertFollowUp(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoCompra', data, {})
}

export function postComment(data: any): AxiosPromise {
  return api.post('v1/Acompanhamento/Comentarios', data, {})
}

export function getComments(
  documentId: number,
  lojaId: number,
  productId: number
): AxiosPromise {
  return api.get(
    `/v1/Acompanhamento/Documentos/${documentId}/Lojas/${lojaId}/Produtos/${productId}/Comentarios`
  )
}

export function postExportAlertPurchase(data: any, _filter: any): AxiosPromise {
  return api.post('v1/Alerta/Compras/Exportar', data, {})
}

export function postExportAlertFollowUp(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoCompra/Exportar', data, {})
}

export function getCommentsExport(
  documentId: number,
  lojaId: number,
  productId: number
): AxiosPromise {
  return api.get(
    `/v1/Acompanhamento/Documentos/${documentId}/Lojas/${lojaId}/Produtos/${productId}/Comentarios/Exportar`
  )
}

// Acompanhamento Reab

export function postExportAlertFollowUpReab(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoReab/Exportar', data, {})
}

export function getSupplyAlertFollowUpReab(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoReab/Fornecedores', data, {})
}

export function getAlertFollowUpReab(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoReab', data, {})
}

// Export
export function getAlertFollowUpExportComment(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoCompra/Comentarios/Exportar', data, {})
}
export function getAlertFollowUpReabExportComment(data: any): AxiosPromise {
  return api.post('v1/AcompanhamentoReab/Comentarios/Exportar', data, {})
}

export function revisaoCompradorFollowUp(data: {
  documentId: number
  storeId: number
  supplierId: number
  itens: Array<{
    productId: number
    novaQuantidade: number | null
    novaDataEntrega: string | null
  }>
}): AxiosPromise {
  return api.post('v1/FollowUpFornecedor/revisao-comprador', data)
}

export function uploadComment({ file: fileUpload }: IUploadData): AxiosPromise {
  const formData = new FormData()
  formData.append('file', fileUpload)
  return api.post('v1/AcompanhamentoCompra/Arquivo/Comentarios', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export default {
  revisaoCompradorFollowUp,
  getSupplyAlertFollowUp,
  getComments,
  getCommentsExport,
  postComment,
  getAlertFollowUpExportComment,
  getAlertFollowUpReabExportComment,
  postExportAlertPurchase,
  getAlertFollowUp,
  postExportAlertFollowUp,
  getPurschaseData,
  postExportAlertFollowUpReab,
  getAlertFollowUpReab,
  uploadComment,
  getSupplyAlertFollowUpReab
}
